import PlainDate from '@Domain/PlainDate';

/**
 * Reads a business date (`YYYY-MM-DD`) as is, and an ISO 8601 instant as the calendar day it falls on
 * in the browser's timezone. `null` stays `null`.
 */
const toPlainDate = (value: string | null): PlainDate | null => {
	if (value === null) {
		return null;
	}

	return PlainDate.fromApi(value) ?? PlainDate.fromCalendar(new Date(value));
};

export default toPlainDate;
